import { GET_PRICE_LISTS, GET_PRICE_LIST, SAVE_PRICE_LIST, DELETE_PRICE_LIST } from "../constants/action-types";

// INITIALIZE STATE
const initialState = {
    priceLists: {},
    priceList: {},
};

// REDUCER
export const PriceListsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRICE_LISTS: {
            var priceLists = {};
            const items = action.payload;

            items.forEach((item) => {
                priceLists[item.id] = item;
            });
        
            return {
                ...state,
                priceLists
            }
        }
        case GET_PRICE_LIST: {
            const priceList = action.payload;

            return {
                ...state,
                priceList: priceList
            }
        }
        case SAVE_PRICE_LIST: {
            const priceList = action.payload;

            var newPriceLists = Object.assign({}, state.priceLists);
            newPriceLists[priceList.id] = priceList;
            
            return {
                ...state,
                priceLists: newPriceLists,
                priceList: priceList
            }
        }
        case DELETE_PRICE_LIST: {
            const priceListIdsToDelete = action.payload;

            var newPriceLists = Object.assign({}, state.priceLists);

            priceListIdsToDelete.forEach((id) => {
                if (newPriceLists.hasOwnProperty(id)) {
                    delete newPriceLists[id];
                }
            })

            return {
                ...state,
                priceLists: newPriceLists,
                priceList: {}
            }
        }
        default:
            return state;
    }
};